import { useCurrentPromo } from '@ecomm/promotions-hooks'
import { useBannerInteractionState } from '@ecomm/promotions-hooks'
import { useRef } from 'react'
import { AIChatButton } from './AIChatButton'
import { useAIChatStyleSheet } from './useAIChatStyleSheet'

/**
 * AIChatBot component
 * Renders the AI chat bot and floating button.
 * @param {string} testMode - Optional. Defaults "true". Enables internal testing of the widget.
 * @param {string} widgetId - Optional. ID of the widget.
 * @returns JSX.Element
 */
export function AIChatBot({ testMode, widgetId }) {
  // Check if a promo is active
  const isPromoActive = useCurrentPromo()
  // Check if the bottom mobile banner has expanded
  const { isVisible, onCloseBanner } = useBannerInteractionState()

  const chatbotRef = useRef(null)

  // Apply custom styles to the chat bot web component chat window
  useAIChatStyleSheet(chatbotRef, isPromoActive)

  return (
    <>
      <alby-chatbot
        ref={chatbotRef}
        widget-id={widgetId}
        test-mode={testMode}
      />
      <AIChatButton
        isPromoActive={isPromoActive}
        isPromoBannerVisible={isVisible}
        onCloseBanner={onCloseBanner}
        widgetId={widgetId}
      />
    </>
  )
}
